var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOzon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 143,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 361,
    height: 142.607,
    rx: 48,
    fill: "#0069FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.038 50.078c-16.455-1.626-30.174 12.088-28.542 28.548 1.204 12.176 11.055 22.027 23.231 23.231 16.455 1.632 30.174-12.087 28.543-28.542-1.205-12.176-11.056-22.027-23.232-23.231v-.006zm11.111 27.7c-.782 6.176-5.777 11.17-11.954 11.953-9.069 1.155-16.727-6.504-15.573-15.572.788-6.183 5.778-11.172 11.954-11.955 9.063-1.154 16.727 6.505 15.573 15.573zM160.014 88.687h-20.645l26.35-34.764c.872-1.154.05-2.808-1.393-2.808h-38.088a6.076 6.076 0 0 0-5.943 7.326c.571 2.863 3.257 4.817 6.171 4.817h16.943L117.037 98.05c-.866 1.143-.05 2.781 1.382 2.781h41.368c2.919 0 5.599-1.954 6.171-4.817a6.077 6.077 0 0 0-5.944-7.326zM291.529 51.254c-2.819.594-4.75 3.214-4.75 6.094v20.218l-32.861-26.068c-1.143-.91-2.83-.094-2.83 1.371v41.746c0 2.88 1.931 5.499 4.751 6.093a6.08 6.08 0 0 0 7.392-5.933v-20.39l32.861 26.068c1.143.91 2.834.094 2.834-1.371V57.187a6.08 6.08 0 0 0-7.391-5.933h-.006zM205.978 49.951c-20.118 0-36.423 11.65-36.423 26.012 0 14.363 16.305 26.012 36.423 26.012 20.118 0 36.423-11.65 36.423-26.012 0-14.363-16.311-26.012-36.423-26.012zm0 39.886c-13.897 0-24.28-7.326-24.28-13.874 0-6.549 10.383-13.874 24.28-13.874 13.897 0 24.28 7.325 24.28 13.874s-10.383 13.874-24.28 13.874z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(60.364 10.652)",
    d: "M0 0h240.272v121.302H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzon);
export default __webpack_public_path__ + "static/media/ozon.64c00493b44aed8961569871cfb64b06.svg";
export { ForwardRef as ReactComponent };